import { css } from '@emotion/react';
import { css as globalCss, theme } from 'global';

const menuMaxWidth = '200px';

export const userIcon = css`
  margin-left: 16px;
  min-width: fit-content;

  ${globalCss.icon(true, '38px', '38px')};
  ${globalCss.backgroundIcon(true)};

  @media screen and (max-width: ${theme.breaks.md}px) {
    order: 3;
  }

  @media screen and (max-width: ${theme.breaks.xs}px) {
    ${globalCss.icon(true, '24px', '24px')};
    ${globalCss.backgroundIcon(false)};
  }
`;

export const menu = css`
  & > .MuiPopover-paper {
    box-shadow: unset;
    border: 1px solid ${theme.colors.neutral[100]};
    margin-top: -8px;
    max-width: ${menuMaxWidth};
  }
`;

export const menuItem = (isClickable = true) => css`
  font-size: 1em;
  line-height: 1.24em;
  min-height: fit-content;
  padding: 12px 24px;
  max-width: ${menuMaxWidth};
  cursor: ${isClickable ? 'pointer' : 'default'};
  &:hover {
    color: ${theme.colors.primary.dark};
    background-color: ${theme.colors.neutral[100]};
  }
`;
